import { Stack, TextInput } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

interface TabGroupGeneralConfigProps {
    form: UseFormReturnType<any>;
    isSaving: boolean;
}

export function TabGroupGeneralConfig({
    form,
    isSaving,
}: TabGroupGeneralConfigProps) {
    return (
        <Stack gap="md">
            <TextInput
                label="Group Name"
                placeholder="e.g., Sales Dashboard Hub"
                disabled={isSaving}
                required
                {...form.getInputProps("name")}
            />

            <TextInput
                label="Description"
                placeholder="Briefly describe what this tab group is for"
                disabled={isSaving}
                {...form.getInputProps("description")}
            />
        </Stack>
    );
}
